export default function Header() {
  return (
    <header>
      <img src="game-logo.png" alt="" />
      <h1>Tic-Tac-Toe</h1>
    </header>
  );
}
